import { memo, useState } from 'react';
import { useFormikContext } from 'formik';
import { StatementsFormVM } from 'front-office/view-models/statements/statements-form';
import Deceased from 'front-office/components/shared/deceased';
import Son from 'front-office/components/statements/request-certificate-modal/statements/son';
import { PmiButton } from 'shell/components/shared/button';
import { Grid, useEventCallback } from '@mui/material';
import { DecasedFormVM } from 'front-office/view-models/certificate/deceased-form';
import { SonFormVM } from 'front-office/view-models/certificate/son-form';

const initialSon: SonFormVM = { isBirthStateItalian: true, isResidenceItalian: true };

const WidowerWithChildrenComponent = (): React.ReactElement => {
  const formContext = useFormikContext<StatementsFormVM>();

  const [currentSons, setCurrentSons] = useState<Array<SonFormVM>>(
    formContext.values.sons || [initialSon]
  );

  const onFieldDecasedChange = useEventCallback(
    (key: keyof DecasedFormVM, value: DecasedFormVM[keyof DecasedFormVM]) => {
      formContext.setFieldValue('decased', {
        ...formContext.values.decased,
        [key]: value,
      });
    }
  );

  const onFieldSonChange = useEventCallback(
    (index: number, key: keyof SonFormVM, value: SonFormVM[keyof SonFormVM]) => {
      const newSons = formContext.values.sons?.slice() || [];

      newSons[index] = {
        ...(newSons[index] || initialSon),
        [key]: value,
      };

      formContext.setFieldValue('sons', newSons);
      setCurrentSons(newSons);
    }
  );

  const onFieldsSonChange = useEventCallback((index: number, values: SonFormVM) => {
    const newSons = formContext.values.sons?.slice() || [];

    newSons[index] = {
      ...(newSons[index] || initialSon),
      ...values,
    };

    formContext.setFieldValue('sons', newSons);
    setCurrentSons(newSons);
  });

  const addSon = useEventCallback(() => {
    setCurrentSons(currentSons.concat(initialSon));
  });

  const onFieldsDeceasedChange = useEventCallback((values: DecasedFormVM) => {
    formContext.setFieldValue('decased', {
      ...formContext.values.decased,
      ...values,
    });
  });

  return (
    <Grid item container spacing={2}>
      <Grid item xs={12}>
        <Deceased
          onFieldDecasedChange={onFieldDecasedChange}
          decased={formContext.values.decased}
          onFieldsDeceasedChange={onFieldsDeceasedChange}
        />
      </Grid>
      <Grid item xs={12}>
        <PmiButton variant="contained" color="primary" type="button" onClick={() => addSon()}>
          Aggiungi figlio
        </PmiButton>
      </Grid>
      {currentSons?.map((son, index) => {
        return (
          <Grid item xs={12} key={`son-${index}`}>
            <Son
              onFieldSonChange={onFieldSonChange}
              onFieldsSonChange={onFieldsSonChange}
              son={son}
              index={index}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};

WidowerWithChildrenComponent.displayName = 'Widower with children component';

const WidowerWithChildren = memo(WidowerWithChildrenComponent);

export default WidowerWithChildren;
